<template>
  <div class="mb-40 mb-40-md my-30-sm flex" v-if="nav">
    <template v-if="type==='parent'">
      <router-link
        v-if="$route.params.parentCategory"
        tag="h4"
        class="pointer underline-hover"
        :to="{name: 'productsFromNavigation',
        params: {
          navItemName: $route.params.parentCategory,
          navItemId: $route.query.navItemId,
        }
      }"
      >
        {{ $route.params.parentCategory }}
      </router-link>
      <h4> / </h4>
    </template>
    <template v-else-if="type==='parent + child'">
      <router-link
        tag="h4"
        class="pointer underline-hover"
        :to="{name: 'productsFromNavigation',
        params: {
          navItemName: $route.params.parentCategory,
          navItemId: getParentId($route.query.navItemId),
        }
      }"
      >
        {{ $route.params.parentCategory }}
      </router-link>
      <h4> / </h4>
      <router-link
        tag="h4"
        class="pointer underline-hover"
        :to="{
        name: 'productsFromNavigation',
        params: {
          navItemParentName:$route.params.parentCategory,
          navItemName: $route.params.category,
          navItemId: $route.query.navItemId,
        }
      }"
      >
        {{ $route.params.category }}
      </router-link>
      <h4> / </h4>
    </template>
    <template v-else-if="type==='parent collection'">
      <router-link
        :to="{
        name: 'ParentCollection',
        params: {
          collectionName: $route.params.parentCategory,
          collectionId: $route.query.collectionId,
        }
       }"
        tag="h4"
        class="pointer underline-hover"
      >
        {{ $route.params.parentCategory }}
      </router-link>
      <h4> / </h4>
    </template>
    <template v-else-if="type==='category + collection'">
      <router-link
        tag="h4"
        class="pointer underline-hover"
        :to="{
          name: 'productsFromNavigation',
          params: {
            navItemName: $route.params.parentCategory,
            navItemId: getParentId($route.query.collectionId),
          }
      }"
      >
        {{ $route.params.parentCategory }}
      </router-link>
      <h4> / </h4>
      <router-link
        :to="{
        name: 'CollectionWithCategory',
        params: {
          categoryName: $route.params.parentCategory,
          collectionName: $route.params.category,
          collectionId: $route.query.collectionId,
        }
       }"
        tag="h4"
        class="pointer underline-hover"
      >
        {{ $route.params.category }}
      </router-link>
      <h4> / </h4>
    </template>
    <template v-else>
      <router-link
        tag="h4"
        :to="{
        name: 'productsFromNavigation',
        params: {
          navItemName: this.category.parent_category_name,
          navItemId: this.getParentId(this.category.id)
        }
      }"
        class="pointer underline-hover"
      >
        {{ category.parent_category_name }}
      </router-link>
      <h4> / </h4>
      <router-link
        tag="h4"
        :to="{
          name: 'productsFromNavigation',
          params: {
            navItemParentName: this.category.parent_category_name,
            navItemName: this.category.name,
            navItemId: this.category.id
          }
        }"
        class="pointer underline-hover"
      >
        {{ category.name }}
      </router-link>
      <h4> / </h4>
    </template>
    <h4>{{ productName }}</h4>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "bread-crumb",
  props: ["category", "productName"],
  computed: {
    ...mapGetters({
      nav: "getNav"
    })
  },
  data: function() {
    return {
      type: ""
    };
  },
  beforeMount() {
    this.determineBreadcrumbTypeFromQueryParams();
  },
  methods: {
    determineBreadcrumbTypeFromQueryParams() {
      if (this.$route.params.parentCategory && this.$route.params.category === undefined && this.$route.query.navItemId) {
        this.type = "parent";
      }
      if (this.$route.params.parentCategory && this.$route.params.category) {
        this.type = "parent + child";
      }
      if (this.$route.query.collectionId && this.$route.params.parentCategory) {
        this.type = "parent collection";
      }
      if (this.$route.params.parentCategory && this.$route.params.category && this.$route.query.collectionId) {
        this.type = "category + collection";
      }
    },
    getParentId(id) {
      let navData = this.$store.getters.getNav,
        result = "";
      navData.children_containers.forEach(category => {
        category.children_containers[0].view_components.forEach(cat2 => {
          if (cat2.entity_id === id || cat2.id === id) {
            result = category.id;

          }
        });
        category.children_containers[1].view_components.forEach(cat2 => {
          if (cat2.entity_id === id || cat2.id === id) {
            result = category.id;

          }
        });
      });
      return result;
    }
  }
};
</script>
